import { render } from "./windows.vue?vue&type=template&id=17a2f415&scoped=true"
import script from "./windows.vue?vue&type=script&lang=js"
export * from "./windows.vue?vue&type=script&lang=js"

import "./windows.vue?vue&type=style&index=0&id=17a2f415&lang=scss&scoped=true"

import exportComponent from "C:\\wamp64\\www\\DDP\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a2f415"]])

export default __exports__